import { render, staticRenderFns } from "./widgetSecVictimIpTopn.vue?vue&type=template&id=044946aa&scoped=true&"
import script from "./widgetSecVictimIpTopn.vue?vue&type=script&lang=js&"
export * from "./widgetSecVictimIpTopn.vue?vue&type=script&lang=js&"
import style0 from "./widgetSecVictimIpTopn.vue?vue&type=style&index=0&id=044946aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044946aa",
  null
  
)

export default component.exports